import React from 'react';
import '../assets/AllTabsCommon.css';

function GrafanaReports() {
    const reportsList = [
        {
            clientId: 1,
            name: "WBC Device Profile",
            dashboardLink: "https://perciphone.lvppr.oks.drekar.qualcomm.com/grafana/d/YGgaB7WNz/device-profile-creator-live-data",
            description: "Captures Network and device health stats for a device."
        },
        {
            clientId: 2,
            name: "Aggregated Report",
            dashboardLink: "https://perciphone.lvppr.oks.drekar.qualcomm.com/grafana/d/e57d69c1-9f32-433d-8e4f-5719641abe59/mbb-aggregated-report",
            description: "Captures aggregated stats across all devices."
        },
        {
            clientId: 3,
            name: "WBC Server Remote Diagnostic Dashboard",
            dashboardLink: "https://wbc.grafana.stage.qualcomm.com/d/55fa2d78-c138-4047-b05b-be385e1595e2/wbc-server-report3a-remote-diagnostic",
            description: "Captures data of remote Diagnostic stats from WBC Server"
        },
        {
            clientId: 4,
            name: "QDKC Remote Diagnostic Dashboard",
            dashboardLink: "https://perciphone.lvppr.oks.drekar.qualcomm.com/grafana/d/a78ddf72-bb34-43ff-a02f-5440673049dc/qdkc-remote-diagnostic-dashboard",
            description: "Captures aggregated Remote Diagnostic stats across all devices from QDKC data"
        },
        {
            clientId: 5,
            name: "WBC Data Validation Report",
            dashboardLink: "https://perciphone.lvppr.oks.drekar.qualcomm.com/grafana/d/a923ab7b-7ba9-4065-861f-277a5d6cbc24/wbc-data-validation?orgId=2",
            description: "Captures the data validation results for the WBC Collector data across all devices"
        }
    ];

    const tableColumns = [
        { key: "name", label: "Name" },
        { key: "dashboardLink", label: "Dashboard Link" },
        { key: "description", label: "Description" },
    ];

    return (
        <div className="grafana-reports">
            <div className="reports-container">
                <div className="data-table-tab-container">
                    <table className="data-table">
                        <thead>
                            <tr>
                                {tableColumns.map((col) => (
                                    <th key={col.key}>{col.label}</th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {reportsList.map((client) => (
                                <tr key={client.clientId}>
                                    {tableColumns.map((col) => (
                                        <td key={col.key}>
                                            {col.key === "dashboardLink" ? (
                                                <a href={client[col.key]} target="_blank" rel="noopener noreferrer">
                                                    {client[col.key]}
                                                </a>
                                            ) : (
                                                client[col.key] || ""
                                            )}
                                        </td>
                                    ))}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
}

export default GrafanaReports;
